import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@components/Button';
import { PrintIcon, RestartIcon } from '@components/Icons';

import styles from '../Table.module.scss';

export interface TableHeaderActionsProps {
  showHeaderActions?: boolean;
  onResetFilter?: () => void;
  onPrint?: () => void;
  renderHeaderActions?: () => ReactElement;
}

const languageNamespace = 'printing-modals';

export const TableHeaderActions = ({
  onResetFilter,
  onPrint,
  renderHeaderActions,
}: TableHeaderActionsProps) => {
  const { t } = useTranslation([languageNamespace]);

  return (
    <div className={styles.headerActions}>
      <div>{renderHeaderActions?.()}</div>
      <div className={styles.defaultActions}>
        <Button appearance="text" text="Reset filter" icon={RestartIcon} onClick={onResetFilter} />
        {onPrint && (
          <Button
            appearance="text"
            text={t('print')}
            icon={() => <PrintIcon size={34.1} />}
            onClick={onPrint}
          />
        )}
      </div>
    </div>
  );
};
